import React from 'react';
import { useTranslation } from 'react-i18next';
import HeaderActionButton from './HeaderActionButton';

/**
 * Cartouche DMBT harmonisé avec le système unifié
 */
const DMBTTrigger = ({ onClick }) => {
  const { t } = useTranslation();
  
  return (
    <HeaderActionButton 
      onClick={onClick}
      gradient="purple"
      className="dmbt-trigger"
    >
      <div className="button-header">
        <div className="button-icon">🧠</div>
        <div className="button-text-content">
          <h3 className="button-title">{t('dmbtTrigger.title')}</h3>
          <p className="button-subtitle">{t('dmbtTrigger.subtitle')}</p>
        </div>
        <span className="button-badge">{t('dmbtTrigger.badge')}</span>
      </div>
      
      <div className="button-features">
        <div className="button-feature">
          <span>🔵</span>
          <span>{t('dmbtTrigger.concepts.nodes')}</span>
        </div>
        <div className="button-feature">
          <span>🔗</span>
          <span>{t('dmbtTrigger.concepts.relations')}</span>
        </div>
        <div className="button-feature">
          <span>🤖</span>
          <span>{t('dmbtTrigger.concepts.aiTests')}</span>
        </div>
      </div>
      
      <div className="button-cta dmbt-trigger-cta">
        <span className="button-cta-text">
          <span className="cta-icon" style={{ marginRight: '8px', fontSize: '1.1em' }}>🧠💡</span>
          {t('dmbtTrigger.buttonText', { defaultValue: 'Découvrir DMBT' })}
        </span>
      </div>
    </HeaderActionButton>
  );
};

export default DMBTTrigger;